import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "current-currency-wrapper"
}
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "currency-item__img" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "currency-short" }
const _hoisted_6 = { class: "currency-name" }
const _hoisted_7 = { class: "clear-wrapper" }
const _hoisted_8 = { class: "clear-label" }
const _hoisted_9 = { class: "currency-list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "currency-item__img" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "currency-short" }
const _hoisted_14 = { class: "currency-name" }

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotCurrencyList',
  emits: ["closeForm", "changeTitle", "setModalHeightAuto"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const auctionStore = useAuctionStore();

  const currency = computed(() => {
    return auctionStore.currency;
  });

  const currencies = computed(() => {
    return auctionStore.currencies;
  });

  const currencyItem = computed(() => {
    return currencies.value?.find((item) => item.abbr === currency.value);
  });

  const setCurrency = (value) => {
    auctionStore.$patch({
      currency: value,
      isCurrencyBase: currencies.value?.find((item) => item.abbr === currency.value).is_base
    });

    emit("closeForm");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (currency.value !== 'USD')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(trans)("modals.currency_modal.selected_currency")), 1),
          _createElementVNode("div", {
            class: "currency-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setCurrency('USD')))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "img",
                src: currencyItem.value.flag_image,
                alt: currencyItem.value.abbr
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(currencyItem.value.abbr), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(currencyItem.value.name), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(trans)("modals.currency_modal.clear_currency")), 1),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon-custom-close" }, [
                _createElementVNode("span", { class: "close-row" }),
                _createElementVNode("span", { class: "close-row" })
              ], -1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencies.value, (currency) => {
        return (_openBlock(), _createElementBlock("div", {
          key: currency.abbr,
          class: "currency-item",
          onClick: ($event: any) => (setCurrency(currency.abbr))
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              class: "img",
              src: currency.flag_image,
              alt: currency.abbr
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, _toDisplayString(currency.abbr), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(currency.name), 1)
        ], 8, _hoisted_10))
      }), 128))
    ])
  ], 64))
}
}

})